import BaseModel from "./BaseModel";

export default class PlaceCity extends BaseModel {
    private _id: number = -1;
    private _title: string = '';
    private _latitude: number = -1;
    private _longitude: number = -1;
    private _population: number = -1;
    private _postcode: string | null = null;


    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }

    get latitude(): number {
        return this._latitude;
    }

    set latitude(value: number) {
        this._latitude = value;
    }

    get longitude(): number {
        return this._longitude;
    }

    set longitude(value: number) {
        this._longitude = value;
    }

    get population(): number {
        return this._population;
    }

    set population(value: number) {
        this._population = value;
    }

    get postcode(): string {
        return this._postcode == null ? "" : this._postcode;
    }

    set postcode(value: string) {
        this._postcode = value;
    }
}
